<script setup lang="ts">
import { ref, computed, markRaw } from 'vue'
import FStepper from '../../feature/FStepper/FStepper.vue'
import type { StepConfig } from '../../feature/FStepper/types'
import AgreementInfo from './steps/AgreementInfo.vue'
import AgreementSign from './steps/AgreementSign.vue'
import type { Agreement } from './types'

const props = defineProps<{
  agreements: Agreement[]
}>()

const stepperModel = ref<Record<string, unknown>>({})
const currentStepNumber = ref(1)

const steps = computed<StepConfig[]>(() => [
  {
    title: 'common.information',
    component: markRaw(AgreementInfo),
    next: {
      label: 'common.next',
      color: 'primary',
    },
  },
  {
    title: 'common.sign_agreement',
    component: markRaw(AgreementSign),
    props: {
      agreements: props.agreements,
    },
    back: {
      label: 'common.back',
      callback: ({ stepNumber }) => stepNumber - 1,
    },
  },
])
</script>

<template>
  <div class="pa-4">
    <f-stepper
      v-model:current-step-number="currentStepNumber"
      v-model="stepperModel"
      :steps="steps"
    />
  </div>
</template>
